import React from 'react';
import FadeIn from '../ui/FadeIn';

const Experience = () => {
  const media = [
    {
      type: 'video',
      src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0606%20(1).mov/ik-video.mp4?updatedAt=1781380963578",
      label: "The Celebration",
      span: "md:col-span-2 md:row-span-2 aspect-[4/5] md:aspect-auto"
    },
    {
      type: 'image',
      src: "https://ik.imagekit.io/aeu02xvjgn/Updated%20images/ChatGPT%20Image%20May%202,%202026,%2007_34_30%20PM.png?updatedAt=1777937947742",
      label: "The Estate",
      span: "md:col-span-1 md:row-span-1 aspect-[4/5] md:aspect-auto"
    },
    {
      type: 'image',
      src: "https://ik.imagekit.io/aeu02xvjgn/Updated%20images/ChatGPT%20Image%20May%202,%202026,%2007_32_58%20PM.png?updatedAt=1777937948311",
      label: "The Ceremony",
      span: "md:col-span-1 md:row-span-1 aspect-[4/5] md:aspect-auto"
    }
  ];

  return (
    <section className="py-16 md:py-32 px-5 md:px-6 bg-charcoal relative overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <FadeIn className="mb-10 md:mb-20">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <div className="max-w-2xl">
              <p className="font-script text-gold text-3xl md:text-4xl mb-3">The October Aesthetic</p>
              <h2 className="font-serif text-[32px] md:text-6xl text-ivory leading-tight">
                Cinematic Moments <br/><span className="italic text-stone/60">at Padua Estate</span>
              </h2>
            </div>
            <div className="w-20 h-px bg-gold/30 mb-4 hidden md:block"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:auto-rows-[320px]">
          {media.map((item, index) => (
            <FadeIn key={index} delay={0.1 * index} className={`relative overflow-hidden group ${item.span}`}>
              {/* Antique Gold Frame Overlay */}
              <div className="absolute inset-0 border border-gold/15 z-20 pointer-events-none group-hover:border-gold/40 transition-colors duration-700 m-3 md:m-4"></div>
              
              {item.type === 'video' ? (
                <video
                  src={item.src}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                />
              ) : (
                <img 
                  src={item.src} 
                  alt={item.label} 
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" 
                />
              )}
              
              {/* Cinematic Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/20 to-transparent opacity-70 group-hover:opacity-50 transition-opacity duration-500"></div>
              
              {/* Label */}
              <div className="absolute bottom-6 left-6 md:bottom-8 md:left-8 z-30">
                <span className="text-ivory font-serif italic tracking-[0.2em] uppercase text-[10px] md:text-xs bg-charcoal/60 backdrop-blur-sm px-4 py-2 border border-gold/20">
                  {item.label}
                </span>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;